import { useState } from 'react';
import { LayoutModule } from '../../../layout/modules';
import { MotiveFilters } from './filters';
import { MotiveList } from './list';
import { MOTIVE, MOTIVE_NEW } from '../../../../routes/paths';
import { Motive as MotiveType } from '../../../../shared/types/systemConfiguration/motives';
import ActionButtonGroup from '../../../components/general/buttons/actionButtonGroup';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';
import { isOnlyViewProfile } from '../../../../shared/types/profiles';

export const Motive = () => {
    const [filters, setFilters] = useState<MotiveType>();

    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    return (
        <>
            <LayoutModule
                title="Búsqueda de motivos"
                showTitle
                additionalButtons={
                    <ActionButtonGroup
                        buttonCreate={{
                            show: !isOnlyViewProfile(type),
                            route: MOTIVE_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: MOTIVE,
                        }}
                    />
                }
            >
                <MotiveFilters onFilter={(filters) => setFilters(filters)} />
            </LayoutModule>
            <MotiveList filters={filters} />
        </>
    );
};
